module.exports = __webpack_public_path__ + "img/Bastelstunde.a002dad1.svg";